import { inject, Injectable, linkedSignal } from '@angular/core';

import { signalMethod } from '@ngrx/signals';

import { CompanyModuleRouterFacade } from '@kros-sk/router-stores/module-router-store';

import { ApplicationModulesStore } from './application-modules.store';

@Injectable()
export class ApplicationModulesFacade {
  readonly #modulesStore = inject(ApplicationModulesStore);
  readonly #routerService = inject(CompanyModuleRouterFacade);

  readonly #module = linkedSignal(this.#routerService.module);

  /** List of available modules */
  readonly modules = this.#modulesStore.entities;

  readonly homeModule = this.#modulesStore.homeModule;

  readonly currentModule = this.#module.asReadonly();

  readonly isLoading$ = this.#modulesStore.isLoading$;

  readonly setModule = signalMethod<string>((module) => this.#module.set(module));
}
